<template>
  <div class="container">
    <common-head></common-head>
    <div class="inner">
      <div class="c-them-body">
        <div class="theme-page">
          <div class="section" v-for="(item, index) of columnData">
            <div class="hd"><span>{{ item.COLUMNNAME }}</span></div>
            <div class="bd" :class="columnShow && item.ID == columnId ? 'open' : ''">
              <div class="item" v-for="temp of belongData.filter(o => o.ColumnId == item.ID)">
                <a :href="$fun.getProductUrl(temp.Id, temp.ProductType)">
                  <div class="img">
                    <!-- <div class="img-tag1">{{temp.SOURCEOPENTYPE == '01' ? '借阅':'畅读' }}</div> -->
                    <template v-if="temp.Cover"><img :src="temp.Cover" /></template>
                    <template v-else><img src="/static/img/np-img.png" /></template>
                    <!-- <span class="img-tag">{{temp.ProductTypeText}}</span> -->
                  </div>
                  <div class="name">{{ temp.Name }}</div>
                </a>
              </div>
            </div>
            <div class="btn-more" v-if="columnShow" @click="handelHide(item.ID)">收起</div>
            <div class="btn-more" v-else @click="handelShow(item.ID)">展开</div>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
export default {
  name: "Theme",
  components: {
    CommonHead,
    CommonFoot,
  },
  data: function () {
    return {
      columnId: "",
      columnData: [],
      columnShow: false,
      belongData: [],
      belongPage: [],
    };
  },
  mounted: function () {
    this.loadColumnData();
  },
  methods: {
    loadColumnData: function () {
      this.$bti.GetColumnList({ PARENTID: this.$route.params.id }).then((res) => {
        this.columnData = res.data;
        for (var i = 0; i < res.data.length; i++) {
          this.$bti.GetBelongToColumnPage({ page: 1, rows: 12, wheres: { ColumnId: res.data[i].ID, OrgId: this.$fun.getMember().orgId, IsSingle: true } }).then((res) => {
            if (res.code != 1) {
              return;
            }
            this.belongData.push(...res.data.rows);
          });
        }
      });
    },
    handelShow: function (id) {
      this.columnId = id;
      this.columnShow = true;
      if (this.belongData.filter(o => o.ColumnId == id).length > 12) {
        return;
      }
      this.$bti.GetBelongToColumnPage({ page: 1, rows: 1000, wheres: { ColumnId: id, OrgId: this.$fun.getMember().orgId, IsSingle: true } }).then((res) => {
        if (res.code != 1) {
          return;
        }
        // 移除已有的数据，在追加
        for (var i = this.belongData.length - 1; i >= 0; i--) {
          if (this.belongData[i].ColumnId == id) {
            this.belongData.splice(i, 1);
          }
        }
        this.belongData.push(...res.data.rows);
      });
    },
    handelHide: function (id) {
      this.columnId = id;
      this.columnShow = false;
    }
  },
};
</script>

<style lang="css" scoped>
.c-them-body {
  padding: 30px 0px;
}


.theme-page {
  background: #fff;
  margin-bottom: 50px;
  padding: 40px;
}

.section .hd {
  position: relative;
  font-size: 24px;
  font-style: italic;
  font-weight: bold;
  padding-bottom: 10px;
  margin-bottom: 25px;
  text-align: center;
}

.section .hd span {
  position: relative;
  min-width: 130px;
  background: #fff;
  padding: 0px 10px;
  z-index: 11;
}

.section .hd:before {
  display: block;
  content: '';
  position: absolute;
  left: calc((100% - 285px)/2);
  top: 15px;
  width: 285px;
  height: 3px;
  background: #2BC0E4;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #feffb0, #c10512, #feffb0);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #feffb0, #c10512, #feffb0);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.section .bd:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.section .bd {
  width: 1110px;
  height: 468px;
  margin-left: -15px;
  padding-bottom: 10px;
  overflow: hidden;
}

.section .bd.open {
  height: auto;
}

.section .bd .item {
  float: left;
  width: 135px;
  margin: 10px 25px;
}

.section .bd .item .img {
  position: relative;
  width: 135px;
  height: 179px;
  box-shadow: 0px 0px 5px #ccc;
  -webkit-box-shadow: 0px 0px 5px #ccc;
  -o-box-shadow: 0px 0px 5px #ccc;
  -moz-box-shadow: 0px 0px 5px #ccc;
}

.section .bd .item .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.section .bd .item .name {
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  color: #333;
}

.btn-more {
  position: relative;
  z-index: 11;
  width: 100px;
  height: 35px;
  line-height: 35px;
  background: #f6ebef;
  text-align: center;
  font-weight: bold;
  color: #ad0606;
  margin: 0px auto 50px auto;
  border-radius: 5px;
  cursor: pointer;
}

.theme-page .section {
  position: relative;
}

.theme-page .section:after {
  display: block;
  content: '';
  position: absolute;
  left: 0px;
  bottom: 15px;
  height: 1px;
  width: 100%;
  background: #eee;
}

.theme-page .section:last-child .btn-more {
  margin-bottom: 0px;
}

.img {
  position: relative;
}

.img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg, #409EFF, #409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
}
</style>



// WEBPACK FOOTER //
// src/pages/theme/Theme.vue